import { render } from "./WhatsappBuy.vue?vue&type=template&id=17742227&scoped=true"
import script from "./WhatsappBuy.vue?vue&type=script&lang=js"
export * from "./WhatsappBuy.vue?vue&type=script&lang=js"

import "./WhatsappBuy.vue?vue&type=style&index=0&id=17742227&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17742227"]])

export default __exports__